import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapState } from "vuex";
export default {
  computed: _objectSpread(_objectSpread({}, mapState("SettingsStore", ["overrides", "isOnThemePreviewMode"])), mapState("AccountStore", ["permissions"])),
  methods: {
    isEnabledForCurrentPlan(permissionType) {
      return this.permissions[permissionType] === "write";
    },
    isEnabledByOverride(overrideType) {
      if (this.settingsType === "brokerage-settings") return true;
      return this.overrides[overrideType] === false;
    },
    getTabDisabledOption({
      key,
      override = ""
    }) {
      var _disabledOptions$find, _disabledOptions$find2;
      const disabledOptions = [{
        key: "disabled-for-customization",
        condition: () => {
          const permissionParam = this.settingsType === "brokerage-settings" ? "brokerageCustomization" : "accountCustomization";
          return !this.isEnabledForCurrentPlan(permissionParam);
        },
        tooltip: this.$t("settings.availableInDoorrProPlan")
      }, {
        key: "disabled-by-override",
        condition: !this.isEnabledByOverride(override),
        tooltip: this.$t("settings.yourBrokerageHasOptedToOverride")
      }, {
        key: "disabled-if-on-theme-preview-mode",
        condition: key === "theme" && this.isOnThemePreviewMode,
        tooltip: this.$t("settings.toggleOffPreviewMode")
      }];
      return (_disabledOptions$find = (_disabledOptions$find2 = _findInstanceProperty(disabledOptions).call(disabledOptions, disabledOption => typeof disabledOption.condition === "function" ? disabledOption.condition() : !!disabledOption.condition)) == null ? void 0 : _disabledOptions$find2.tooltip) != null ? _disabledOptions$find : "";
    }
  }
};